import { quoteConsultingText } from "i18n/consulting";
import React from "react";
import { useSelector } from "react-redux";

const QuoteConsult = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = quoteConsultingText[lang];

  return (
    <section className="bg-black py-16 px-6">
      {/* Main Quote */}
      <div className="mx-auto border border-white/70 px-6 md:px-16 py-14 md:py-20 text-center">
        <div className="max-w-5xl mx-auto space-y-6">
          {/* Title */}
          <h2
            className="text-white font-semibold leading-tight
                       text-2xl sm:text-3xl md:text-4xl lg:text-3xl font-[Crimson]"
          >
            {t.desc}
          </h2>
        </div>
      </div>
    </section>
  );
};

export default QuoteConsult;
